import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import BoxMui from '@mui/material/Box';
import Button from '@mui/material/Button';

type ParamsStyle = {
    theme?: Theme;
    recommended: string;
    typeproduct: string;
    isOne: string;
}

export const Box = styled(BoxMui)(
    ({ theme, recommended, typeproduct, isOne }: ParamsStyle) => `
        width: 290px;
        display: flex;
        textAlign: center;
        align-items: center;
        flex-direction: column;
        justify-content: start;

        .content-card {
            width: 100%;
            height: 100%;
            border-radius: .625rem;
            padding: 1.6rem 0rem;
            border: 2px solid ${theme?.palette.primary.main}; 

            h6 {
                text-align: center;
                padding: 0;
            }
        }

        .content-recommended {
            width: 100%;
            height: ${typeproduct === 'activeContainer' ? '3.4rem' : '0px'};
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;

            p {
                display: none;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 252px;

            .content-card {
                padding: 1.6rem 0rem;
            }

            .content-recommended {
                width: 100%;

                .activeContainer {
                    height: 3.4rem;
                }
            }
        }


        ${(recommended === 'active' || (isOne === 'active')) && `
            border-radius: ${isOne === 'active' ? '.625rem' : '0 0 10px 10px'};
            border: ${isOne === 'active' ? `2px solid ${theme?.palette.primary.main}` : `5px solid ${theme?.palette.primary.light}`};
            .content-card {
                border: none;
            }

            .content-recommended {
                height: 3rem;
                background-color: ${theme?.palette.primary.light};

                p {
                    display: block;
                }
            }

            @media(min-width: ${theme?.breakpoints.values.md}px) {
                width: 260px;
                border: ${isOne === 'active' ? `2px solid ${theme?.palette.primary.main}` : `8px solid ${theme?.palette.primary.light}`};
            }
        `}
`);

export const BoxList = styled(BoxMui)(
    ({ theme }: { theme?: Theme }) => `
    width: 100%;
    max-width: 100%;
    padding-top: 1.65rem;

    ul {
        gap: .4rem;
        display: flex;
        flex-direction: column;

        li {
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: start;
            
            p {
                text-align: start;
            }
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        max-width: 100%;

        ul {
            li {
                gap: 0;
                display: flex;
                justify-content: center;
                height: 20px;
    
                p {
                    display: none;
                }
            }
        }
    }
`);

export const ContendModal = styled('div')(
    ({ theme }: { theme?: Theme }) => `
    display: flex;
    gap: .75rem;
    flex-direction: column;

    h6 {
        font-size: 1.125rem;

        strong {
            font-size: 2.5rem;
            line-height: 30px;
        }
    }

    button {
        width: 100%;
        max-width: 12.125rem;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        gap: 1.43rem;

        &.modal-start-stop {
            gap: .7875rem;
        }

        h6 {
            font-size: 1.56rem;
            
            strong {
                font-size: 3.43rem;
                line-height: 45px;
            }
        }

        button {
            max-width: 16.875rem;
        }
    }
`);

export const ButtonCustom = styled(Button)(
    ({ theme, selected }: { theme?: Theme, selected?: 'active' | 'disabled' }) => `
        width: 6.3rem;
        font-size: .8125rem;
        padding: .44rem 0 .3rem;
        border-radius: 1.5625rem;
        transition: 100ms;
        background-color: ${selected === 'active' ? theme?.palette.secondary.main : 'transparent'};
        color: ${selected === 'active' ? 'white' : theme?.palette.primary.main};
        font-weight: ${selected === 'active' ? '700' : '400'};

        &:hover {
            background-color: ${theme?.palette.secondary.light};
            font-weight: 700;
        }
`);